import { useMemo } from "react";
import { UserProfileIcon } from "@/components/shared/icons";
import { IfElse } from "@/components/shared/if-else";
import { Text, View } from "@/components/ui";
import { getUserNameShortCut } from "@/lib/helpers/string";
import { useAuthState } from "@/store/auth";

import { useAuth } from "../../auth-provider";

export function UserAvatar({ badged }: { badged?: boolean }) {
  const {
    data: { userInfo },
  } = useAuthState();

  const nameShortCut = useMemo(() => {
    return getUserNameShortCut({
      firstName: userInfo.firstName,
      lastName: userInfo.lastName,
    });
  }, [userInfo]);

  const { isAuthenticated } = useAuth();

  return (
    <View>
      <IfElse
        if={isAuthenticated}
        else={
          <View className="rounded-full bg-white">
            <UserProfileIcon className="color-brand-primary h-8 w-8" />
          </View>
        }
      >
        <View className="text-brand-primary relative flex size-8 items-center justify-center rounded-full bg-white">
          <IfElse if={!!badged}>
            <View className="absolute right-0 top-0 flex size-3 items-center justify-center rounded-full bg-white">
              <View className="bg-danger size-2 rounded-full"></View>
            </View>
          </IfElse>
          <Text>{nameShortCut}</Text>
        </View>
      </IfElse>
    </View>
  );
}
